export const DYNAMIC_FIELD_TRIGGER = '{{';
